module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_3009.2f648931.png";